module.exports = __webpack_public_path__ + "static/about-avatar.3f437c69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-avatar.jpg
// module id = 200
// module chunks = 107818501498521 198182681891205